const DASHBOARD_TIME_RANGES = {
  '30m': { duration: 30 * 60, step: 60 },
  '6h': { duration: 6 * 3600, step: 5 * 60 },
  '24h': { duration: 24 * 3600, step: 10 * 60 },
  '7d': { duration: 7 * 86400, step: 30 * 60 },
  '30d': { duration: 30 * 86400, step: 60 * 60 },
};

const LOGS_TIME_RANGES = {
  '30m': { duration: 30 * 60, step: 60 },
  '6h': { duration: 6 * 3600, step: 5 * 60 },
  '24h': { duration: 24 * 3600, step: 10 * 60 },
  '7d': { duration: 7 * 86400, step: 30 * 60 },
  '30d': { duration: 30 * 86400, step: 60 * 60 },
};

const PRESET_TIME_RANGES = {
  ...DASHBOARD_TIME_RANGES,
  ...LOGS_TIME_RANGES,
};

const getTimeRangeParams = (rangeKey, ranges = DASHBOARD_TIME_RANGES) => {
  const config = ranges[rangeKey] || PRESET_TIME_RANGES[rangeKey];

  if (!config) {
    throw new Error(`Unsupported time range: ${rangeKey}`);
  }

  const end = Math.floor(Date.now() / 1000);
  const start = end - config.duration;

  return { start, end, step: config.step };
};

export { DASHBOARD_TIME_RANGES, LOGS_TIME_RANGES, getTimeRangeParams };

